import {createSlice} from '@reduxjs/toolkit';

export const stateSlice = createSlice({
    name: 'future',
    initialState: {
        name: "",
        birthDate: {},
        birthPlace: "",
        birthTime: {},
        gender: "",
        zodiacSign: "",
        howFamiliar: "",
    },
    reducers: {
        setName: (state, action) => {
            state.name = action.payload
        },
        setBirthDate: (state, action) => {
            state.birthDate = action.payload
        },
        setBirthPlace: (state, action) => {
            state.birthPlace = action.payload
        },
        setBirthTime: (state, action) => {
            state.birthTime = action.payload
        },
        setGender: (state, action) => {
            state.gender = action.payload
        },
        setZodiacSign: (state, action) => {
            state.zodiacSign = action.payload
        },
        setHowFamiliar: (state, action) => {
            state.howFamiliar = action.payload
        },
    }
})

export const {
    setName,
    setBirthDate,
    setBirthPlace,
    setBirthTime,
    setGender,
    setZodiacSign,
    setHowFamiliar
} = stateSlice.actions

export default stateSlice.reducer